<template>
    <b-row class="mb-0">
        <b-col>
            <div id="page-content">
                <slot></slot>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
  name: 'VPageContent'
}
</script>

<style scoped>
    #page-content {
        padding: 1rem 1rem;
        height: 100%;
    }
</style>
